import { assignAchievement as aA } from "src/components/Leaderboard";
import VideoModal from "src/components/VideoModal";
import { userID } from "src/utils/datalayer";
import { ModalWrapper } from "src/utils/fw";
import { leaderboardOptIn, modalColor } from "../utils";
import { dismiss } from "./modals/HTEP";
import BoothPopup from "../components/BoothPopup";

const assignAchievement = async (data) => {
    if (!leaderboardOptIn) return;

    return aA(data)
}


export default {
    background: "https://assets.swoogo.com/uploads/full/4590302-672147cf3838c.png",
    links: [
        {
            label: "ThreatLocker Logo",
            width: "44.3%",
            height: "14%",
            left: "36.5%",
            top: "18.4%",
            modalOverrides: dismiss,
            modal: <BoothPopup
                companyName="ThreatLocker"
                companyUrl="http://www.threatlocker.com/"
                image="https://assets.swoogo.com/uploads/medium/3986527-6658129fa9d5c.png"
                room="platinum"
                text="Stop ransomware! ThreatLocker® improves enterprise-level server and endpoint security with zero trust controls, including Allowlisting, Ringfencing™, Elevation, Storage, Network Control, Configuration Management, and Operational Alert solutions."
                socialMedia={[
                    {name: "Facebook", url: "https://www.facebook.com/thethreatlocker/"},
                    {name: "Instagram", url: "https://www.instagram.com/threatlocker/"},
                    {name: "X", url: "https://twitter.com/ThreatLocker"},
                    {name: "YouTube", url: "https://www.youtube.com/threatlocker"}
                ]}
            />
        },
        {
            label: "ThreatLocker Contact Us",
            href: "mailto:sales@threatlocker.com",
            onClick: () => {
                assignAchievement({
                    achievementId: "ea11b4d8-6c9b-40fd-959b-b0754e751ee2",
                    eventId: "161759",
                    userId: userID
                })
            },
            isExternal: true,
            target: "_blank",
            width: "10.5%",
            height: "32.7%",
            left: "76.3%",
            top: "58%",
        },
        {
            label: "ThreatLocker video",
            href: "",
            onClick: () => {
                assignAchievement({
                    achievementId: "49fd8bdd-9e03-48a6-b4e4-417b0b307372",
                    eventId: "161759",
                    userId: userID
                })
            },
            modalOverrides: dismiss,
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://player.vimeo.com/video/1024786015?h=e89c351280&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1" />
            </ModalWrapper>,
            width: "23.3%",
            height: "27%",
            left: "40.5%",
            top: "39.4%",
        },
        {
            label: "ThreatLocker view demo",
            href: "",
            modalOverrides: dismiss,
            onClick: () => {
                assignAchievement({
                    achievementId: "a47f4d56-fdc0-4684-a464-09d5e87189c6",
                    eventId: "161759",
                    userId: userID
                })
            },
            modal: <ModalWrapper wrapperStyle={{
                background: modalColor,
                aspectRatio: "16 / 9",
                width: "50%",
                minWidth: "700px"
            }}>
                <VideoModal url="https://youtu.be/_E_DWY0Ncq0?si=JL88xWn_zFjh02fG&autoplay=1" />
            </ModalWrapper>,
            width: "7.3%",
            height: "34%",
            left: "30.9%",
            top: "36.4%",
        },
        {
            label: "ThreatLocker PDF File",
            href: "https://assets.swoogo.com/uploads/4598599-6723d4a79eaf4.pdf",
            onClick: () => {
                assignAchievement({
                    achievementId: "f7989caa-6970-4686-850e-d362c669ba50",
                    eventId: "161759",
                    userId: userID
                })
            },
            target: "_blank",
            width: "7.3%",
            height: "34%",
            left: "65.9%",
            top: "36.4%",
        },
        {
            label: "Back to Exhibition Hall",
            href: "/exhibition-hall",
            width: "14.3%",
            height: "8%",
            left: "44.9%",
            top: "89.4%",
        }
    ],
    name: "exhibition-hall-platinum"
}